const menuNames = {
  machines: "Machines",
  cabins: "Cabins",
  trays: "Trays",
  products: "Products",
  "product-grouping": "Product grouping",
  "fill-products": "Fill products",
  "payment-methods": "Payment methods",
  "payment-management": "Payment management",
  "sales-report": "Sales report",
  "admin-accounts": "Admin accounts",
  distributors: "Distributors",
  "filling-persons": "Filling persons",
  "machine-admin": "Machine admin",
  customers: "customers",
  "product-category": "Product categories",
  "product-validation": "Product validation",
  "ad-images": "Advertisement images",
  "ad-videos": "Advertisement videos",
  "customer-profiles": "Customer profiles",
  "sms-provider": "SMS service provider",
  "alert-settings": "Alert settings",
  "manage-payment-split": "Manage payment split",
  "daily-settlements": "Daily settlements",
  "manage-locations": "Manage locations",
  "event-offers": "Event offers",
  "invoice-configuration": "Invoice Configuration",
};
export default menuNames;
